import React from 'react';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Slider4 from '../Elements/Slider4';
import About3 from '../Elements/About3';
// import Specialization3 from '../Elements/Specialization3';
import OurValue2 from '../Elements/OurValue2';
// import OurProject4 from '../Elements/OurProject4';
import OurServices4 from '../Elements/OurServices4';
// import OurValue3 from '../Elements/OurValue3';
// import Team2 from '../Elements/Team2';
// import Blogs2 from '../Elements/Blogs2';
import Faq from '../Elements/Faq';
// import Testimonials from '../Elements/Testimonials';
import Testimonials2 from '../Elements/Testimonials2';
// import Calendar from '../Elements/Calendar';

class Home4 extends React.Component {
    render() {
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Slider4 />
                    <About3 />
                    <OurServices4 />
                    {/* <OurProject4 /> */}
                    <OurValue2 />
                    {/* <Specialization3 /> */}
                    <Testimonials2/>

                    {/* <OurValue3 /> */}
                    {/* <Team2 /> */}
                    {/* <Blogs2 /> */}
                    <Faq />
                    {/* <Calendar
          calendarId="interiorsenn@gmail.com"
          timeZone="Asia/Kolkata"
        /> */}
                </div>
                <Footer />
            </>
        );
    };
};

export default Home4;